import { MessageService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as message from './types';

const actions = {
  async [message.FETCH_MESSAGE_BROWSER_TOKENS](context, params) {
    const { data } = await MessageService.getBrowserTokens(params);
    return data;
  },
  async [message.UPDATE_MESSAGE_BROWSER_TOKENS](context, params) {
    const { data } = await MessageService.setBrowserTokens(params);
    return data;
  },
};

export default actions;
